import { LoadingSpinner } from "../../LoadingSpinner";
import { ChartHeader } from "../ChartHeader";
import { CHART_HEIGHT } from "../ChartConstants";

type ChartSuspenseProps = {
  titleText: string;
};

export const ChartSuspense = ({ titleText }: ChartSuspenseProps) => {
  return (
    <>
      <ChartHeader titleText={titleText} />
      <LoadingSpinner mixin={{ height: `${CHART_HEIGHT}px` }} />
    </>
  );
};
